export enum ProgressionStatusType {
  SUCCESS = 'SUCCESS',
  SETTING_UP = 'SETTING_UP',
  ERROR = 'ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
  UNKNOWN = 'UNKNOWN',
}
